import axios from 'axios';
import cookie from 'js-cookie';

const API_BASE_URL = process.env.REACT_APP_API_URL;

const authHeaders = () => ({
    withCredentials: true,
    headers: {
        'X-XSRF-TOKEN': cookie.get('XSRF-TOKEN'),
    },
});

export const fetchDashboard = async (businessId) => {
    const response = await axios.get(
        `${API_BASE_URL}/usage-dashboard/${businessId}`,
        authHeaders()
    );
    return response.data;
};
